/* eslint-disable no-undef */
import { handleResponse } from '../Helpers/handle-response';
import { authHeader } from '../Helpers/auth-header';

export const authenticationService = {
    login,
    userInfo
};

function login(username, password) {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    
    var urlencoded = new URLSearchParams();
    urlencoded.append("client_id", "flagstone-employee");
    urlencoded.append("client_secret", "codemazesecret");
    urlencoded.append("grant_type", "password");
    urlencoded.append("username", username);
    urlencoded.append("password", password);
    urlencoded.append("scope", "openid poc.backend.api");

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: urlencoded,
      redirect: 'follow'
    };
    return fetch(`${process.env.REACT_APP_AUTHURL}/token`, requestOptions).then(handleResponse);
}

function userInfo(userToken) {
  const requestOptions = { method: 'GET', headers: authHeader(userToken) };
  return fetch(`${process.env.REACT_APP_AUTHURL}/userinfo`, requestOptions).then(handleResponse);
}